import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { SectionDiv, SummaryDiv } from '../TextStyle'
import { juItems } from './JointUtilizationItems'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'

const sectionTitle = {
  // titleText: 'Joint Utilization',
  subTitleText: 'トライアルグループおよび株式会社SU-PAY間における個人情報の共同利用',
}

const tSummary = (
  <p>
    トライアルグループおよび株式会社SU-PAYは、その保有する個人情報につきまして、トライアルグループ内において適切な保護措置を講じた上で、プライバシーポリシー「第2条（利用目的）」の範囲内で、以下に定めるとおり共同利用することがあります。
  </p>
)

export const JointUtilization = () => {
  return (
    <>
      <Head
        title="共同利用"
        description="トライアルグループおよび株式会社SU-PAY間における個人情報の共同利用。"
        ogp={{ type: 'article', url: 'legal/privacy-policy/' }}
      />
      <PrivacyContainer>
        <SectionTitle
          color="normal"
          // titleText={sectionTitle.titleText}
          subTitleText={sectionTitle.subTitleText}
        />
        <Spacer h={{ pc: 70, sp: 60 }} />
        <SummaryDiv>{tSummary}</SummaryDiv>
        <Spacer h={{ pc: 46, sp: 35 }} />
        
        {juItems.map(({ children, id }, index, array) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < array.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}
      </PrivacyContainer>
    </>
  )
}
JointUtilization.getLayout = (page: ReactElement) => {
  const pageTitle = {
    title: 'LEGAL',
    subTitle: '法務',
  }

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '法務', path: '/legal/' },
    { name: 'プライバシーポリシー', path: '/legal/privacy-policy/' },
    { name: '個人情報の共同利用', path: '' },
  ]

  return (
    <TitleLayout
      {...pageTitle}
      breadCrumbs={breadCrumbs}
      isRequiredBackground={false}
    >
      {page}
    </TitleLayout>
  )
}

const PrivacyContainer = styled.div`
  width: 1040px;
  padding-top: 62px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 68px;
  }

  #privacy7 {
    margin-top: -105px;
    padding-top: 105px;
  }

  @media screen and (max-width: 1047px) {
    #privacy7 {
      margin-top: -53px;
      padding-top: 53px;
    }
  }
`
